export default "__VITE_ASSET__9d2b455f__"